/**
  Renders a `<thead>` element and yields the row component.

  ```hbs
  <table.thead as |head|>
    <head.row as |row|>
      <row.column @prop="firstName" as |column|>
        First name
        {{if column.isAscSorted "(sorted asc)"}}
        {{if column.isDescSorted "(sorted desc)"}}
      </row.column>
    </head.row>
  </table.thead>
  ```

  @class THead
  @yield {object} head
  @yield {Component} head.row
*/ import { template as template_c58d398b81ed4e2ea058242c2e1d7466 } from "@ember/template-compiler";
import { hash } from '@ember/helper';
import THead from './thead/row.gjs';
// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default template_c58d398b81ed4e2ea058242c2e1d7466(`
  <thead class={{@theme.thead}} ...attributes>
    {{yield
      (hash
        row=(component
          THead
          sortable=@sortable
          sortSequence=@sortSequence
          onColumnClick=@onColumnClick
          columns=@columns
          theme=@theme
          parent=@parent
        )
      )
    }}
  </thead>
`, {
    eval () {
        return eval /**
 * Adds a click action to the thead, called with the clicked column as an argument.
 *
 * @argument onColumnClick - action that is called when the column header is clicked
 * @type Function
 */ (arguments[0]);
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9taWd1ZWwvd29ya3NwYWNlL2VtYmVyLXlldGktdGFibGUvZW1iZXIteWV0aS10YWJsZS9zcmMvY29tcG9uZW50cy95ZXRpLXRhYmxlL3RoZWFkLmdqcyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAgUmVuZGVycyBhIGA8dGhlYWQ-YCBlbGVtZW50IGFuZCB5aWVsZHMgdGhlIHJvdyBjb21wb25lbnQuXG5cbiAgYGBgaGJzXG4gIDx0YWJsZS50aGVhZCBhcyB8aGVhZHw-XG4gICAgPGhlYWQucm93IGFzIHxyb3d8PlxuICAgICAgPHJvdy5jb2x1bW4gQHByb3A9XCJmaXJzdE5hbWVcIiBhcyB8Y29sdW1ufD5cbiAgICAgICAgRmlyc3QgbmFtZVxuICAgICAgICB7e2lmIGNvbHVtbi5pc0FzY1NvcnRlZCBcIihzb3J0ZWQgYXNjKVwifX1cbiAgICAgICAge3tpZiBjb2x1bW4uaXNEZXNjU29ydGVkIFwiKHNvcnRlZCBkZXNjKVwifX1cbiAgICAgIDwvcm93LmNvbHVtbj5cbiAgICA8L2hlYWQucm93PlxuICA8L3RhYmxlLnRoZWFkPlxuICBgYGBcblxuICBAY2xhc3MgVEhlYWRcbiAgQHlpZWxkIHtvYmplY3R9IGhlYWRcbiAgQHlpZWxkIHtDb21wb25lbnR9IGhlYWQucm93XG4qL1xuaW1wb3J0IHsgaGFzaCB9IGZyb20gJ0BlbWJlci9oZWxwZXInO1xuaW1wb3J0IFRIZWFkIGZyb20gJy4vdGhlYWQvcm93Lmdqcyc7XG5cbi8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBlbWJlci9uby1lbXB0eS1nbGltbWVyLWNvbXBvbmVudC1jbGFzc2VzXG48dGVtcGxhdGU-XG4gIDx0aGVhZCBjbGFzcz17e0B0aGVtZS50aGVhZH19IC4uLmF0dHJpYnV0ZXM-XG4gICAge3t5aWVsZFxuICAgICAgKGhhc2hcbiAgICAgICAgcm93PShjb21wb25lbnRcbiAgICAgICAgICBUSGVhZFxuICAgICAgICAgIHNvcnRhYmxlPUBzb3J0YWJsZVxuICAgICAgICAgIHNvcnRTZXF1ZW5jZT1Ac29ydFNlcXVlbmNlXG4gICAgICAgICAgb25Db2x1bW5DbGljaz1Ab25Db2x1bW5DbGlja1xuICAgICAgICAgIGNvbHVtbnM9QGNvbHVtbnNcbiAgICAgICAgICB0aGVtZT1AdGhlbWVcbiAgICAgICAgICBwYXJlbnQ9QHBhcmVudFxuICAgICAgICApXG4gICAgICApXG4gICAgfX1cbiAgPC90aGVhZD5cbjwvdGVtcGxhdGU-XG4vKipcbiAqIEFkZHMgYSBjbGljayBhY3Rpb24gdG8gdGhlIHRoZWFkLCBjYWxsZWQgd2l0aCB0aGUgY2xpY2tlZCBjb2x1bW4gYXMgYW4gYXJndW1lbnQuXG4gKlxuICogQGFyZ3VtZW50IG9uQ29sdW1uQ2xpY2sgLSBhY3Rpb24gdGhhdCBpcyBjYWxsZWQgd2hlbiB0aGUgY29sdW1uIGhlYWRlciBpcyBjbGlja2VkXG4gKiBAdHlwZSBGdW5jdGlvblxuICovXG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQWtCQTtBQUNBLFNBQVMsSUFBSSxRQUFRLGdCQUFnQjtBQUNyQyxPQUFPLFdBQVcsa0JBQWtCO0FBRXBDLG9FQUFvRTtBQUNwRSxlQUFBLDBDQUFVLENBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7QUFnQlYsQ0FBQSxFQUFBO0lBQUE7UUFBQSxPQUFBLEtBQ0E7Ozs7O0NBS0MsSUFORCxTQUFBLENBQUEsRUFBVztJQUFEO0FBQUEsR0FBQyJ9